export default __webpack_public_path__ + "static/media/icons.c6004482.svg";